<template>
    <div class="form-item">
        <label class="label-caption">Tipo Documento</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        tipoSelecionado: {type: String, default: null}
    },

    data() {
        return{
            lsTipos:[
                {id: 'CF', descricao: 'Cupom Fiscal/NFCe'},
                {id: 'NF', descricao: 'Nota Fiscal'},
                {id: 'NP', descricao: 'Nota de Produtor'},
                {id: 'NS', descricao: 'Nota de Serviço'}
            ]
        };
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', event.target.value);
        }
    }
};
</script>